import request from '@/utils/request'
import aes from '@/common/aes.js'
import { loginAES, tokenName } from '@/config'

export async function api_postLogin(data) {
  if (loginAES) {
    data.password = aes.encrypt(data.password)
  }
  return request({
    url: '/rest/login',
    method: 'post',
    data,
  })
}

export function api_postGetUserInfo(accessToken) {
  return request({
    url: '/userInfo',
    method: 'post',
    data: {
      [tokenName]: accessToken,
    },
  })
}

export function api_postLogout() {
  return request({
    url: '/logout',
    method: 'post',
  })
}

export function api_postRegister() {
  return request({
    url: '/register',
    method: 'post',
  })
}

export function api_putRestPassword(data) {
  if (loginAES) {
    data.oldPassword = aes.encrypt(data.oldPassword)
    data.newPassword = aes.encrypt(data.newPassword)
  }
  return request({
    url: '/rest/password',
    method: 'put',
    data
  })
}

export function api_getLogout(data) {
  return request({
    url: '/rest/logout',
    method: 'get',
    data
  })
}